
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MarakezService } from 'src/app/services/marakez.service';
import { RepairRequestService } from 'src/app/services/repair-request.service';

@Component({
    selector: 'repair-request',
    templateUrl: 'repair-request.component.html'
})

export class RepairRequestComponent implements OnInit {

    serialNumber: FormControl = new FormControl('');
    markazId: FormControl = new FormControl('0');
    traceNumber: FormControl = new FormControl('');
    code: FormControl = new FormControl('');
    repairInPlace: FormControl = new FormControl(false, []);

    searchForm: FormGroup = new FormGroup({
        serialNumber: this.serialNumber,
        markazId: this.markazId,
        traceNumber: this.traceNumber,
        code: this.code,
        repairInPlace: this.repairInPlace
    });

    description: FormControl = new FormControl('', [Validators.required]);
    requestForm: FormGroup = new FormGroup({
        description: this.description
    });

    receiverAddress: FormControl = new FormControl("");
    senderAddress: FormControl = new FormControl("");
    addressForm: FormGroup = new FormGroup({
        receiverAddress: this.receiverAddress,
        senderAddress: this.senderAddress
    });

    pollingText: FormControl = new FormControl('');
    pollingForm: FormGroup = new FormGroup({
        pollingText: this.pollingText
    });

    message: string = '';
    showInfo: boolean = false;
    showVerificationCode: boolean = false;
    maskedMobile = '';
    waiting: boolean = false;
    remainingCodeTime: number = 120;
    timerHandle: number;
    marakezOptions: [] = [];
    markazItem: {} = {};
    requestMode: number = 2; // 1 --> traceNumber; 2 --> markazId and serialNumber
    
    info: any = {};
    statusInfo: any = {};
    status = 0;
    currentStep: number = 1;

    constructor(private repairService: RepairRequestService, private marakezService: MarakezService) { }

    ngOnInit() { }

    resetProps() {
        this.message = '';
        this.showInfo = false;
        this.showVerificationCode = false;
        this.code.reset();
    }
    clearInfo() {
        this.statusInfo = {};
        this.info = {};
    }

    searchInput(e) {
        let key = e.keyCode || e.which;
        if (key == 13) {
            //console.log('search...', key);
            if (this.showVerificationCode) {
                this.verifyCode();
            }
            else {
                this.search();
            }
        }
    }

    marakezInput(e) {
        let phrase = e.target.value;
        if (phrase.length > 2) {
            this.marakezService.loadList(phrase).subscribe((resp: any) => {
                if (resp.status == 0) {
                    this.marakezOptions = resp.data;
                }
            });
        }
    }

    clearMarkazOptions() {
        this.marakezOptions = [];
        //this.markazId.reset();
    }

    markazSelected(item) {
        this.markazItem = item;
        //this.markazId.setValue(item.fMarkazID);
        this.marakezOptions = [];
        //(document.getElementById('marakez') as any).value = `${item.fNameMarkaz} (${item.fNameModirMarkaz})`;
    }

    startTimer() {
        this.remainingCodeTime = 120;
        this.timerHandle = window.setInterval(() => {
            this.remainingCodeTime--;
            if (this.remainingCodeTime == 0) {
                window.clearInterval(this.timerHandle);
            }
        }, 1000);
    }

    printDiv() {
        // if (confirm("آیا وضعیت به در حال ارسال تغییر کند؟")) {

        // }

        var printContents = document.getElementById(`print-content`).innerHTML;
        var w;
        w = window.open();
        w.document.write(printContents);
        w.print();
        w.close();
    }

    search() {
        //console.log('serial number', this.serialNumber.value);
        if (this.requestMode == 1 && !this.traceNumber.value) {
            this.searchForm.setErrors({ incorrect: true });
        }
        else if (this.requestMode == 2 && (!this.serialNumber.value)) {
            this.searchForm.setErrors({ incorrect: true });
        }
        if (this.searchForm.valid) {
            this.resetProps();
            this.waiting = true;
            this.repairService.authMobile(this.serialNumber.value).subscribe((resp: any) => {
                this.waiting = false;
                console.log('response: ', resp);
                if (resp.status == 0) {
                    // show verification code
                    this.showVerificationCode = true;
                    this.maskedMobile = resp.data.mobile;
                    this.receiverAddress.setValue(resp.data.receiverAddress);
                    this.senderAddress.setValue(resp.data.senderAddress);
                    this.status = resp.data.status;
                    debugger;
                    this.startTimer();
                }
                else {
                    // show message
                    this.message = resp.message;
                }
            }, err => {
                this.waiting = false;
                console.error('error: ', err);

                alert('بروز خطا. لطفا با پشتیبانی تماس بگیرید!');
            });
        }
        else {
            if (this.requestMode == 1) {
                alert('شماره پیگیری را وارد کنید.');
            }
            else {
                alert('شماره سریال دستگاه و مرکز را وارد کنید.');
            }
        }
    }

    verifyCode() {
        if (this.code.value.length == 6) {

            this.waiting = true;
            this.repairService.verifyCode(this.serialNumber.value, this.code.value).subscribe((resp: any) => {
                this.waiting = false;
                console.log('response: ', resp);
                this.message = '';
              
                if (resp.status == 0) {
                    
                    window.clearInterval(this.timerHandle);
                    this.showVerificationCode = false;
                    this.showInfo = true;
                    
                    this.info = resp.data.soldProducts;
                   debugger;
                    this.markazId.setValue(this.info.fMarkazID);
                 
                    if (resp.data.repairRequests) {
                      debugger;
                        this.statusInfo = resp.data.repairRequests;
                        debugger;
                        this.description.setValue(this.statusInfo.issueDescription);
                      
                        if (this.statusInfo.statusId == 7 || this.statusInfo.statusId == 100) {
                            debugger;
                            this.currentStep = this.statusInfo.statusId;
                        }
                        else {
                            debugger;
                            this.currentStep = this.statusInfo.statusId ;
                        }
                        debugger;
                        this.status = this.statusInfo.statusId;
                    }
                }
                else {
                    debugger;
                    // show message
                    this.message = resp.message;
                }
            }, err => {
                debugger;
                this.waiting = false;
                console.error('error: ', err);

                alert('بروز خطا. لطفا با پشتیبانی تماس بگیرید!');
            });
        }
        else {
            debugger;
            alert('لطفا کد 6 رقمی و صحیح را وارد کنید.');
        }
    }

    sendRequest() {
        debugger;
        if (this.requestForm.valid && this.description.value.length > 19) {
            this.waiting = true;
            this.repairService.saveRequest({ 
                SerialNumber: this.info.fSerialNumber
                , Description: this.description.value
                , MarkazId: this.markazId.value 
                , repairInPlace: this.repairInPlace.value
            }).subscribe((resp: any) => {
                this.waiting = false;
                this.message = resp.message;
                debugger;
                this.showInfo = false;

                this.requestForm.reset();
                this.clearInfo();
                //this.resetProps();
            }, err => {
                this.waiting = false;
                console.error('error: ', err);
                this.requestForm.reset();

                alert('بروز خطا. لطفا با پشتیبانی تماس بگیرید!');
            });
        }
        else {
            alert('شرح خرابی دستگاه را وارد کنید. حداقل 20 کاراکتر.')
        }
    }
    printAddress(){

        var  pagePrint=window.open();
        pagePrint.document.write(`<html>
        <style>
        @font-face {
            font-family: iransans;
            src: url(../assets/fonts/iransans.ttf);
          }
          
        @page { size: landscape; }
          p {
              font-size: 40px;
              font-family: iransans;
            
          }
        </style>
        <body dir="rtl">
          <div>
            <div>
              <div><p class="font-iransans ">آدرس گیرنده:</p></div>
              <div><p class="font-iransans ">${this.receiverAddress.value}</p></div>
            </div>
            <hr />
            <div>
              <div><p class="font-iransans ">آدرس فرستنده:</p></div>
              <div><p class="font-iransans ">${this.senderAddress.value}</p></div>
            </div>
          </div>
        </body>
      </html>`);
        setTimeout(()=>{


        
            pagePrint.document.close();
            pagePrint.print();
        },100)
      
    }

    saveAddress() {
        this.repairService.saveRequest({
            serialNumber: this.info.fSerialNumber,
            description: this.description.value,
            address: this.senderAddress.value
        })
            .subscribe((resp: any) => {
                this.waiting = false;
                this.message = resp.message;

                this.showInfo = false;

                this.requestForm.reset();
            }, err => {
                this.waiting = false;
                console.error('error: ', err);
                this.requestForm.reset();

                alert('بروز خطا. لطفا با پشتیبانی تماس بگیرید!');
            });
    }

    goToStep(step: number, e) {
        debugger;
        if (this.statusInfo.statusId && step <= this.statusInfo.statusId + 1) {
            this.currentStep = step;
        }
        return;
    }

    between(item, a, b) {
        return item >= a && item <= b;
    }

    payment() {
        debugger;
        this.repairService.beginPayment(this.statusInfo.fCode).subscribe((resp: any) => {
            console.log('resp: ', resp);
            debugger;
            if (resp.status == 0) {
                window.location.replace(resp.data.paymentUrl);
                debugger;
            }
            else {
                alert(resp.message);
                debugger;
            }
        });
    }

    sendPolling() {
        this.waiting = true;
        this.repairService.savePolling({
            requestId: this.statusInfo.id,
            pollingDescription: this.pollingText.value,
            fCode:this.statusInfo.fCode
        }).subscribe((resp: any) => {
            this.waiting = false;
            if (resp.status == 0) {
                alert(resp.message);
                window.location.reload();
            }
        }, err => {
            this.waiting = false;
            console.error('polling error: ', err);

            alert('خطا در هنگام ذخیره سازی نظرسنجی.');
        });
    }

    changeRequestMode(mode: number) {
        this.requestMode = mode;
    }
}